(function () {
    
    const dropDownButton = document.querySelector('.navigation > .hamburger');
    if (!dropDownButton) return;

    let toggle = false;
    const navigationMenu = document.querySelector(".navigation > .navigation-menu")

    const hamburger = document.createElement('img')
    hamburger.src = "../blog/assets/images/hamburger.png"
    hamburger.alt = "Menu"
    
    const close = document.createElement('img')
    close.src = "../blog/assets/images/close.png"
    close.alt = "Close"


    dropDownButton.appendChild(hamburger)
    dropDownButton.addEventListener('click', (e) => {
        
        navigationMenu.classList.toggle("expanded")
        let open = navigationMenu.classList.contains("expanded")

        if(open){
           try{
            dropDownButton.removeChild(dropDownButton.firstChild)
           }
           catch {}
            dropDownButton.appendChild(close)
        }
        else{
            try{
                dropDownButton.removeChild(dropDownButton.firstChild)
               }
               catch {}
            dropDownButton.appendChild(hamburger)
        }
    })


})();
